import React from "react";
import { Button, Group, Text } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { STYLE } from "../types/constants";
import { SHARED_I18N_NAMESPACE } from "../i18n";

export const APP_UPDATE_BANNER_HEIGHT = 48;

export const AppUpdateBanner: React.FC<{ onUpdate: () => void }> = ({
  onUpdate,
}) => {
  const { t } = useTranslation(SHARED_I18N_NAMESPACE);

  return (
    <Group
      h={APP_UPDATE_BANNER_HEIGHT}
      px="md"
      gap="md"
      justify="center"
      wrap="nowrap"
      style={{
        backgroundColor: STYLE.primary,
        color: "white",
        flexShrink: 0,
      }}
      data-testid="app-update-banner"
    >
      <Text size="sm" fw={600}>
        {t("components.appUpdateBanner.message")}
      </Text>
      <Button
        size="xs"
        variant="white"
        leftSection={<IconRefresh size={16} />}
        onClick={onUpdate}
        data-testid="app-update-banner-button"
      >
        {t("components.appUpdateBanner.updateButton")}
      </Button>
    </Group>
  );
};
